import { useState } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { useIntegrationAccessReview } from '@/features/chat/phase1/useIntegrationAccessReview'
import { useConnectedIntegrationsAnnouncement } from '@/features/chat/phase1/useConnectedIntegrationsAnnouncement'
import IntegrationAccessPermissionDialog from './IntegrationAccessPermissionDialog'
import IntegrationAccessRequestCards from './IntegrationAccessRequestCards'
import { splitAccessGroups } from './splitAccessGroups'

export default function IntegrationAccessRequestBlock({ block }) {
  const [showPermissions, setShowPermissions] = useState(false)
  const review = useIntegrationAccessReview(block)
  useConnectedIntegrationsAnnouncement(review.connectedToolkits)
  const current = review.review ?? block
  const { pending, approved } = splitAccessGroups(current.groups)
  const deferred = current.status === 'deferred'
  return (
    <Stack sx={{ gap: 1.25, maxWidth: 728 }}>
      <IntegrationAccessRequestCards
        groups={current.groups ?? []}
        connectingToolkit={review.connectingToolkit}
        onConnect={review.connect}
        deferred={deferred}
      />
      {deferred ? <Typography sx={{ fontSize: 'var(--app-font-size-body)', fontWeight: 'var(--app-font-weight-regular)', letterSpacing: 0, color: 'var(--app-text-primary)' }}>Saved for later.</Typography> : pending.length ? <Button size="small" onClick={review.defer} sx={{ alignSelf: 'flex-start', px: 0.5, fontSize: 'var(--app-font-size-body)', fontWeight: 'var(--app-font-weight-regular)', letterSpacing: 0, color: 'var(--app-text-secondary)' }}>Not now</Button> : null}
      {approved.length ? <Button size="small" onClick={() => setShowPermissions(true)} sx={{ alignSelf: 'flex-start', px: 0.5, fontSize: 'var(--app-font-size-body)', fontWeight: 'var(--app-font-weight-regular)', letterSpacing: 0, color: 'var(--app-text-secondary)' }}>View permissions</Button> : null}
      {review.error ? <Typography color="error" sx={{ fontSize: 'var(--app-font-size-body)', letterSpacing: 0 }}>{review.error}</Typography> : null}
      <IntegrationAccessPermissionDialog open={showPermissions} onClose={() => setShowPermissions(false)} groups={approved} />
    </Stack>
  )
}
